import { render } from "./ExampleArea.vue?vue&type=template&id=0231ff7f"
import script from "./ExampleArea.vue?vue&type=script&lang=js"
export * from "./ExampleArea.vue?vue&type=script&lang=js"

import "./ExampleArea.vue?vue&type=style&index=0&id=0231ff7f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__